import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import ExpandableText from '../ExpandableText';

const ExpandableHTML = ({
  text,
}) => {
  return (
    <ExpandableText>
      <div
        dangerouslySetInnerHTML={{ __html: text }}
      />
    </ExpandableText>
  );
};

export default ExpandableHTML;

